import React, { PropTypes } from 'react';
import classnames from 'classnames';
import max from 'lodash/max';
import Money from 'common/components/money';

/**
 * Simple horizontal bars graph.
 * Data is passed in a dictionary, as in the example below:
 * data = {
 *    title: 'Some Tile',
 *    items: [
 *      {
 *        label: 'Text Label',
 *        value: 4
 *      }, {
 *        label: <MyLabelComponent />,
 *        value: 7,
 *        money: true
 *      }
 *    ]
 * }
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const HorizontalBars = ({ data, className, placeInside }) => {
  const { title, items } = data;
  const maxValue = max(items.map(i => i.value));

  return (
    <div className={classnames("horizontal-bars", { "place-inside": placeInside }, className)}>
      <h4>{ title }</h4>
      <table>
        <tbody>
          { items.map((item, i) => {
            const maxBarWidth = placeInside? 90 : 70;
            const barWidth = (item.value/maxValue * maxBarWidth).toString() + "%";

            const value = (
              <div className="value">
                { item.money? <Money value={item.value} /> : item.value }
              </div>
            );

            return (
              <tr key={i}>
                { !placeInside && <td className="label-cell">{ item.label }</td> }

                <td className="bar-cell">
                  <div className="bar" style={{ width: barWidth }}>
                    { placeInside && item.label }
                    { placeInside && value }
                  </div>

                  { !placeInside && value }
                </td>
              </tr>);
          }) }
        </tbody>
      </table>
    </div>);
}


/**
 * PropTypes.
 *
 * @property {object} data - graph data
 * @property {bool} placeInside - whether to place labels and values inside the bar
 * @property {string} className - additional CSS classes
 */
HorizontalBars.propTypes = {
  data: PropTypes.object.isRequired,
  placeInside: PropTypes.bool,
  className: PropTypes.string
};

export default HorizontalBars;



// WEBPACK FOOTER //
// ./common/components/horizontal_bars.jsx